<template>
  <div class="alipay-flow-page">
    <div class="phone-screen">
      <img class="screen-image" :src="screenImage" alt="支付宝账户与安全页面" />
      <button class="hotspot back-arrow" type="button" aria-label="返回上一页" @click="goBack" />
      <button class="hotspot home-btn" type="button" aria-label="回到主页" @click="goHome" />
      <button class="hotspot identity-info" type="button" aria-label="进入身份信息" @click="goIdentityInfo" />
    </div>
  </div>
</template>

<script>
import screenImage from "@/assets/alipay-account-security-page-no-status.png";

export default {
  name: "AlipayAccountSecurityPage",
  data() {
    return { screenImage };
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    goHome() {
      this.$router.push({ name: "AlipayFlowHome" });
    },
    goIdentityInfo() {
      this.$router.push({ name: "AlipayIdentityInfoPage" });
    },
  },
};
</script>

<style scoped>
.alipay-flow-page {
  min-height: 100vh;
  background: #eff2f7;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  box-sizing: border-box;
}
.phone-screen {
  position: relative;
  width: 100vw;
  height: 100vh;
}
.screen-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: fill;
}
.hotspot {
  position: absolute;
  border: none;
  background: transparent;
  cursor: pointer;
}
.back-arrow {
  left: 1.5%;
  top: 0.8%;
  width: 9%;
  height: 6%;
}
.home-btn {
  right: 1.5%;
  top: 0.8%;
  width: 9%;
  height: 6%;
}
.identity-info {
  left: 5%;
  top: 40.8%;
  width: 90%;
  height: 6%;
}
</style>
